/** *
 * Custom dropdown indicator for control
 */
import PropTypes from 'prop-types';
import React from 'react';

import ArrowSelector from '../../../images/arrow-down.svg';

const CustomDropdownIndicator = ({ selectProps: { inlineSearch } }) => {
  if (inlineSearch) return null;
  return <img alt="dropdown-icon" src={ArrowSelector} />;
};

CustomDropdownIndicator.propTypes = {
  selectProps: PropTypes.object,
};

export default CustomDropdownIndicator;
